/* eslint-disable max-len */
import React from 'react'
import { ShimmerThumbnail, ShimmerSimpleGallery } from "react-shimmer-effects";


const ResourceSkeleton = () => {
    return (

        <div className="lg:px-[54px] md:px-[46px] px-4">
            <div className='pt-[30px]'>
                <ShimmerSimpleGallery card imageHeight={300} row={2} col={4} gap={20} />
            </div>

        </div>
    )
}

export default ResourceSkeleton


